module.exports = __webpack_public_path__ + "static/media/settings_darkbleu.1056b9f7.svg";